import "./sass/_typography.scss";
import "./assets/styles/_common.scss";

export const initializeDL = () => {
  console.log("Design language initialised");
};
